import { useMemo } from 'react';

import useScreenSize from '@hooks/useScreenSize';
import getWidthPercentageBySize from '@services/images/getWidthPercentageBySize';

function useScreenWidthBySize(size) {
  const { screenWidth } = useScreenSize();

  const calculatedWidth = useMemo(() => {
    if (!screenWidth) return 0;
    const percentage = getWidthPercentageBySize(size);
    return Math.round(screenWidth * percentage);
  }, [size, screenWidth]);

  return calculatedWidth;
}

export default useScreenWidthBySize;
